export { default } from './Text';